/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { get, put } from '@/services/api/client';
import { ApiResponse } from '@/services/api/types';
import { OrganizationSettingsDto, SettingDefinition } from '@/types/superadmin.types';

const BASE_URL = '/organizations/my-settings';

export const orgSettingsService = {
  async getSettings(): Promise<OrganizationSettingsDto> {
    const response = await get<ApiResponse<OrganizationSettingsDto>>(BASE_URL);
    return response.data;
  },

  async updateSettings(settings: Record<string, string | null>): Promise<OrganizationSettingsDto> {
    const response = await put<ApiResponse<OrganizationSettingsDto>>(BASE_URL, { settings });
    return response.data;
  },

  async getAvailableSettings(): Promise<SettingDefinition[]> {
    const response = await get<ApiResponse<SettingDefinition[]>>(`${BASE_URL}/available`);
    return response.data;
  },
};
